import env from "../../env.js";
import { post } from "../http/post.js";

const apiURL = env.VITE_API_URL;

// this function may be better emitting an event and having a delay in
// its "instantiation", so to speak.
// Perhaps be without internal conditions and composed with some delegation function
// But this feature is mostly a prototype for now
export const remoteLog = async ({ contextName, data, logLevel }) => {
  const { useMainStore } = await import("../../../main/store/mainStore.js");

  const mainStore = useMainStore();

  if (!mainStore.sendLogs) {
    return;
  }

  const productKey = mainStore.productKey;

  await post(`${apiURL}/v4/alerters/${productKey}/log`, {
    json: [{ contextName, data, logLevel }],
  }).catch((error) => console.log(error));
};
